import tw from 'twin.macro'

export const selectButtonBaseStyles = tw`text-left justify-start px-4 mb-2 mr-4 last:mb-0`
export const selectButtonActiveStyles = tw`ring-2 ring-inset ring-tGreen`
